import template from './readingGuide.html'
import css from './readingGuide.css'

const BASE_HEIGHT = 160
const MARGIN = 20

function fontSizeMultiplier(): number {
  const v = Number((globalThis as { __asw__fontSize?: number }).__asw__fontSize)
  return Number.isFinite(v) && v > 0 ? v : 1
}

function applyHeight(slit: HTMLElement): void {
  slit.style.height = `${Math.round(BASE_HEIGHT * fontSizeMultiplier())}px`
}

function applyPosition(slit: HTMLElement, clientY: number): void {
  const h = slit.offsetHeight
  const vh = window.visualViewport?.height ?? window.innerHeight
  slit.style.top = `${Math.max(MARGIN, Math.min(clientY - h / 2, vh - h - MARGIN))}px`
}

let onScroll: ((event: PointerEvent) => void) | null = null

export default function readingGuide(enable = false) {
  let guide = document.querySelector('.asw-rg-container')

  if (enable) {
    if (!guide) {
      guide = document.createElement('div')
      guide.classList.add('asw-rg-container')
      guide.innerHTML = `<style>${css}</style>${template}`

      const slit: HTMLElement = guide.querySelector('.asw-rg')!
      applyHeight(slit)

      onScroll = (event) => applyPosition(slit, event.clientY)
      applyPosition(slit, Math.floor((window.visualViewport?.height ?? window.innerHeight) / 2))

      window.addEventListener('pointermove', onScroll, { passive: false })
      document.body.appendChild(guide)
    } else {
      const slit: HTMLElement = guide.querySelector('.asw-rg')!
      applyHeight(slit)
    }
  } else {
    guide?.remove()

    if (onScroll) {
      window.removeEventListener('pointermove', onScroll)
      onScroll = null
    }
  }
}

/** Updates the live slit height to match the current fontSize multiplier. */
export function syncReadingGuideHeight(): void {
  const slit = document.querySelector<HTMLElement>('.asw-rg-container .asw-rg')
  if (slit) applyHeight(slit)
}
